// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../fonts/clario/Clario-Thin.woff2");
var ___CSS_LOADER_URL_IMPORT_1___ = require("../fonts/clario/Clario-ThinItalic.woff2");
var ___CSS_LOADER_URL_IMPORT_2___ = require("../fonts/clario/Clario-Air.woff2");
var ___CSS_LOADER_URL_IMPORT_3___ = require("../fonts/clario/Clario-AirItalic.woff2");
var ___CSS_LOADER_URL_IMPORT_4___ = require("../fonts/clario/Clario-Light.woff2");
var ___CSS_LOADER_URL_IMPORT_5___ = require("../fonts/clario/Clario-LightItalic.woff2");
var ___CSS_LOADER_URL_IMPORT_6___ = require("../fonts/clario/Clario-Regular.woff2");
var ___CSS_LOADER_URL_IMPORT_7___ = require("../fonts/clario/Clario-RegularItalic.woff2");
var ___CSS_LOADER_URL_IMPORT_8___ = require("../fonts/clario/Clario-Medium.woff2");
var ___CSS_LOADER_URL_IMPORT_9___ = require("../fonts/clario/Clario-MediumItalic.woff2");
var ___CSS_LOADER_URL_IMPORT_10___ = require("../fonts/clario/Clario-Bold.woff2");
var ___CSS_LOADER_URL_IMPORT_11___ = require("../fonts/clario/Clario-BoldItalic.woff2");
var ___CSS_LOADER_URL_IMPORT_12___ = require("../fonts/clario/Clario-Black.woff2");
var ___CSS_LOADER_URL_IMPORT_13___ = require("../fonts/clario/Clario-BlackItalic.woff2");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Clario';
  font-style: normal;
  font-weight: 100;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
}

@font-face {
  font-family: 'Clario';
  font-style: italic;
  font-weight: 100;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
}

@font-face {
  font-family: 'Clario';
  font-style: normal;
  font-weight: 200;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
}

@font-face {
  font-family: 'Clario';
  font-style: italic;
  font-weight: 200;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2');
}

@font-face {
  font-family: 'Clario';
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2');
}

@font-face {
  font-family: 'Clario';
  font-style: italic;
  font-weight: 300;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff2');
}

@font-face {
  font-family: 'Clario';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2');
}

@font-face {
  font-family: 'Clario';
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff2');
}

@font-face {
  font-family: 'Clario';
  font-style: normal;
  font-weight: 500 600;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2');
}

@font-face {
  font-family: 'Clario';
  font-style: italic;
  font-weight: 500 600;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff2');
}

@font-face {
  font-family: 'Clario';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff2');
}

@font-face {
  font-family: 'Clario';
  font-style: italic;
  font-weight: 700;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff2');
}

@font-face {
  font-family: 'Clario';
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff2');
}

@font-face {
  font-family: 'Clario';
  font-style: italic;
  font-weight: 900;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff2');
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/styles/clario.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAmE;AACrE;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAA4D;AAC9D;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAkE;AACpE;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAA8D;AAChE;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAoE;AACtE;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAgE;AAClE;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAsE;AACxE;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,4DAA+D;AACjE;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,4DAAqE;AACvE;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6DAAmE;AACrE;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6DAA8D;AAChE;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6DAAoE;AACtE","sourcesContent":["@font-face {\n  font-family: 'Clario';\n  font-style: normal;\n  font-weight: 100;\n  font-display: swap;\n  src: url('../fonts/clario/Clario-Thin.woff2') format('woff2');\n}\n\n@font-face {\n  font-family: 'Clario';\n  font-style: italic;\n  font-weight: 100;\n  font-display: swap;\n  src: url('../fonts/clario/Clario-ThinItalic.woff2') format('woff2');\n}\n\n@font-face {\n  font-family: 'Clario';\n  font-style: normal;\n  font-weight: 200;\n  font-display: swap;\n  src: url('../fonts/clario/Clario-Air.woff2') format('woff2');\n}\n\n@font-face {\n  font-family: 'Clario';\n  font-style: italic;\n  font-weight: 200;\n  font-display: swap;\n  src: url('../fonts/clario/Clario-AirItalic.woff2') format('woff2');\n}\n\n@font-face {\n  font-family: 'Clario';\n  font-style: normal;\n  font-weight: 300;\n  font-display: swap;\n  src: url('../fonts/clario/Clario-Light.woff2') format('woff2');\n}\n\n@font-face {\n  font-family: 'Clario';\n  font-style: italic;\n  font-weight: 300;\n  font-display: swap;\n  src: url('../fonts/clario/Clario-LightItalic.woff2') format('woff2');\n}\n\n@font-face {\n  font-family: 'Clario';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url('../fonts/clario/Clario-Regular.woff2') format('woff2');\n}\n\n@font-face {\n  font-family: 'Clario';\n  font-style: italic;\n  font-weight: 400;\n  font-display: swap;\n  src: url('../fonts/clario/Clario-RegularItalic.woff2') format('woff2');\n}\n\n@font-face {\n  font-family: 'Clario';\n  font-style: normal;\n  font-weight: 500 600;\n  font-display: swap;\n  src: url('../fonts/clario/Clario-Medium.woff2') format('woff2');\n}\n\n@font-face {\n  font-family: 'Clario';\n  font-style: italic;\n  font-weight: 500 600;\n  font-display: swap;\n  src: url('../fonts/clario/Clario-MediumItalic.woff2') format('woff2');\n}\n\n@font-face {\n  font-family: 'Clario';\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url('../fonts/clario/Clario-Bold.woff2') format('woff2');\n}\n\n@font-face {\n  font-family: 'Clario';\n  font-style: italic;\n  font-weight: 700;\n  font-display: swap;\n  src: url('../fonts/clario/Clario-BoldItalic.woff2') format('woff2');\n}\n\n@font-face {\n  font-family: 'Clario';\n  font-style: normal;\n  font-weight: 900;\n  font-display: swap;\n  src: url('../fonts/clario/Clario-Black.woff2') format('woff2');\n}\n\n@font-face {\n  font-family: 'Clario';\n  font-style: italic;\n  font-weight: 900;\n  font-display: swap;\n  src: url('../fonts/clario/Clario-BlackItalic.woff2') format('woff2');\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
